<template>
  <div class="top-events-table">
    <div v-if="events.length === 0" class="no-data-message">
      {{ $t('dashboard.events.no_data') }}
    </div>
    <template v-else>
      <table class="events-table">
        <thead>
          <tr>
            <th class="event-name-header">{{ $t('dashboard.events.table.event_name') }}</th>
            <th class="capacity-header">{{ $t('dashboard.events.table.capacity') }}</th>
            <th class="online-header hide-on-narrow">{{ $t('dashboard.events.table.online') }}</th>
            <th class="organizer-header hide-on-narrow">{{ $t('dashboard.events.table.organizer') }}</th>
            <th class="date-header hide-on-narrow">{{ $t('dashboard.events.table.date') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in events" :key="event.id">
            <td class="event-name">{{ event.title }}</td>
            <td class="capacity">{{ event.capacity > 0 ? event.capacity.toLocaleString() : '-' }}</td>
            <td class="online hide-on-narrow">{{ event.is_online == 1 ? '○' : '-' }}</td>
            <td class="organizer hide-on-narrow">{{ event.store_name || '-' }}</td>
            <td class="date hide-on-narrow">{{ formatDateRange(event.start_date, event.end_date) }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script setup>
import { colors } from '../../../../consts/colors';

const props = defineProps({
  events: {
    type: Array,
    default: () => []
  }
});

// Format date range for display
const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return '-';

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Format: YYYY/MM/DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  const formattedStart = formatDate(start);
  const formattedEnd = formatDate(end);

  // If same date, show only once
  if (formattedStart === formattedEnd) {
    return formattedStart;
  }

  return `${formattedStart} - ${formattedEnd}`;
};
</script>

<style lang="scss" scoped>
.top-events-table {
  .no-data-message {
    font-size: 14px;
    color: v-bind('colors.gray[400]');
    text-align: center;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 120px;
    margin-bottom: 120px;
  }

  .events-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    th {
      padding: 12px 8px;
      text-align: left;
      font-size: 12px;
      font-weight: 600;
      color: v-bind('colors.gray[500]');
      border-bottom: 2px solid v-bind('colors.gray[200]');
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    td {
      padding: 12px 8px;
      font-size: 13px;
      color: v-bind('colors.textPrimary');
      border-bottom: 1px solid v-bind('colors.gray[300]');
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.event-name {
        // color: v-bind('colors.blue[500]');
        color: v-bind('colors.textPrimary');
      }
    }

    // Default: 5 columns (all visible)
    .event-name-header,
    .event-name {
      width: 35%;
    }

    .capacity-header,
    .capacity {
      width: 10%;
    }

    .online-header,
    .online {
      width: 10%;
    }

    .organizer-header,
    .organizer {
      width: 20%;
    }

    .date-header,
    .date {
      width: 25%;
    }

    // Narrow view: 3 columns (70:15:15 ratio)
    @media (max-width: 700px) {
      .hide-on-narrow {
        display: none;
      }

      .event-name-header,
      .event-name {
        width: 70%;
      }

      .capacity-header,
      .capacity {
        width: 30%;
      }
    }
  }
}
</style>
